import { doc, getDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Domain from '../../models/Domain';
import getAIBySubscriptionId from '../ai/getAIBySubscriptionId';

async function getDomainBySubscription(subscriptionId: string): Promise<Domain> {
  try {
    const db = firestore;
    
    const ai = await getAIBySubscriptionId(subscriptionId);
    if (!ai) {
      throw new GetDomainBySubscriptionFailure(
        `AI with subscription id "${subscriptionId}" not found`,
        'not-found'
      );
    }

    const domainRef = doc(db, FirestoreCollections.domains, ai.domain);
    const domainSnapshot = await getDoc(domainRef);

    if (!domainSnapshot.exists()) {
      throw new GetDomainBySubscriptionFailure(
        `Domain with id "${ai.domain}" not found`,
        'not-found'
      );
    }

    return Domain.fromFirestore(domainSnapshot);
  } catch (e) {
    console.log('error: ', e);
    throw new GetDomainBySubscriptionFailure();
  }
}

export class GetDomainBySubscriptionFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getDomainBySubscription;
